import SimpleType from "sap/ui/model/SimpleType";
import ValidateException from "sap/ui/model/ValidateException";


export default class PasswordType extends SimpleType {


        public formatValue(vValue: any, sTargetType: string): any | Promise<any> {
            return vValue;
        }

        public  parseValue(vValue: any, sSourceType: string): any | Promise<any> {
            return vValue;
        }
        public static validate(vValue: any): string[]{
            let validationErrors:string[] = [];
            let regex:RegExp;

            if (vValue.length < 8) {
                validationErrors.push("MIN_LENGTH_ERROR");
            }

            if (vValue.length > 32) {
                validationErrors.push("MAX_LENGTH_ERROR");
            }

            regex = /\d/;
            if (!regex.test(vValue)) {
                validationErrors.push("ONE_DIGIT_ERROR");
            }

            regex = /[a-z]/;
            if (!regex.test(vValue)) {
                validationErrors.push("ONE_LOWER_CASE_ERROR");
            }

            regex = /[A-Z]/;
            if (!regex.test(vValue)) {
                validationErrors.push("ONE_UPPER_CASE_ERROR");
            }

            regex = /[!\"#$%&()*+,-./:;<=>?@\[\]_{|}~]/;
            if (!regex.test(vValue)) {
                validationErrors.push("ONE_SPECIAL_CHARACTER_ERROR");
            }


            return validationErrors;
        }

}
